import React from 'react';
import { FiAlertTriangle, FiX, FiCheck, FiShield } from 'react-icons/fi';

const BrokerActionPopup = ({ isOpen, onClose, onProceed, onCancel, brokerName }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50">
      <div className="bg-gray-900 rounded-xl p-6 w-full max-w-md mx-4 border border-red-500/30">
        {/* Header */}
        <div className="flex items-center gap-3 mb-4">
          <div className="w-10 h-10 bg-red-500/20 rounded-full flex items-center justify-center">
            <FiAlertTriangle className="w-6 h-6 text-red-400" />
          </div>
          <div>
            <h3 className="text-lg font-bold text-white">⚠️ Action Required: Open Positions Detected</h3>
          </div>
        </div>

        {/* Content */}
        <div className="space-y-4 mb-6">
          <p className="text-gray-300 leading-relaxed">
            You are attempting to change your broker connection while QFAA is managing an active position. 
            If you proceed, QFAA will no longer manage your open trades.
          </p>

          <div className="bg-red-500/10 border border-red-500/30 rounded-lg p-4">
            <div className="flex items-start gap-3">
              <FiShield className="w-5 h-5 text-red-400 mt-0.5 flex-shrink-0" />
              <div className="space-y-2">
                <p className="text-red-300 text-sm font-medium">⚠️ Automated monitoring, risk controls, and exits will stop.</p>
                <p className="text-red-300 text-sm">⚠️ Your positions will remain in your brokerage account, but you must manage them manually.</p>
              </div>
            </div>
          </div>

          <div className="bg-green-500/10 border border-green-500/30 rounded-lg p-4">
            <div className="flex items-start gap-3">
              <FiCheck className="w-5 h-5 text-green-400 mt-0.5 flex-shrink-0" />
              <p className="text-green-300 text-sm font-medium">
                ✅ To avoid risk, please close all active positions before switching brokers.
              </p>
            </div>
          </div>
        </div>

        {/* Actions */}
        <div className="flex gap-3">
          <button
            onClick={onCancel}
            className="flex-1 px-4 py-3 bg-gray-700 hover:bg-gray-600 text-white font-medium rounded-lg transition-colors"
          >
            Cancel
          </button>
          <button
            onClick={onProceed}
            className="flex-1 px-4 py-3 bg-red-600 hover:bg-red-700 text-white font-medium rounded-lg transition-colors"
          >
            Proceed Anyway
          </button>
        </div>

        {/* Close button */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 p-2 text-gray-400 hover:text-white transition-colors"
        >
          <FiX className="w-5 h-5" />
        </button>
      </div>
    </div>
  );
};

export default BrokerActionPopup; 